export const checkMicrophonePermission = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach((track) => track.stop()); // Stop the audio track to release the microphone
    return true; // Permission granted
  } catch (err) {
    return false; // Permission denied
  }
};
